import {IColumn} from 'models';

export const getFilteredLPColumns = (columns: IColumn[]) => columns.filter((col) => col.id !== 'status');
